import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import AppText from '../../../common/AppText';
import { useMemo } from 'react';
import {boxSettingsProps, USER_FIELDS, USER_SITE_FIELDS} from '../../../../services/ConstHelper';
import { t } from '../../../../services/i18n';
import CustomTaskDoneCheckbox from '../../../common/CustomTaskDoneCheckbox';
import { Colors } from '../../../../styles/Colors';
import { useSelector } from 'react-redux';
import InfoTooltip from "../../../common/InfoTooltip";
import {HStack} from "native-base";
import usePermissions from "../../../../services/Permissions";
import CheckboxTable from "../../../common/CheckboxTable";

const RequiredFieldsSettings = ({initialValues, values, setFieldValue, infoTooltip, ...rest}) => {
    const {has} = usePermissions()
    let {fields, flows} = useMemo(() => boxSettingsProps[initialValues?.prop_name] || {}, [initialValues]);
    flows = flows.filter(flow => !has('allowRegisterGroupMember') ? flow !== 'child' : true)
    const box = useSelector(state => state.box.box);
    const isGlobal = box?.locations_box[0]?.country_code !== 'IL';

    const isDisabled = (field, flow) => {
        let globalDisabled
        switch (initialValues?.prop_name) {
            case USER_FIELDS:
                globalDisabled = isGlobal ? ['city.member', 'address.member'] : [];
                return [...globalDisabled, 'first_name.member', 'first_name.lead', 'last_name.member', 'source_fk.member', 'users_boxes_owner_id.member', 'personal_id.lead'].includes(`${field}.${flow}`);
            case USER_SITE_FIELDS:
                globalDisabled = isGlobal ? ['personal_id.member', 'personal_id.lead', 'personal_id.child'] : [];
                return [...globalDisabled, 'first_name.member', 'first_name.lead', 'first_name.child', 'last_name.member', 'last_name.lead', 'last_name.child', 'email.child', 'phone.member'].includes(`${field}.${flow}`);
            default:
                return false;
        }
    }

    const isDefaultChecked = (field, flow) => {
        if(field === 'last_name' && flow === 'child') {
            return true
        }
        return values.properties?.[field]?.[`${flow}Required`]
    }

    return (
        <CheckboxTable columns={flows}
                       rows={fields}
                       mainColumnName={t('field-name')}
                       isDisabled={isDisabled}
                       isChecked={(field, flow) => values.properties?.[field] === undefined ? true : isDefaultChecked(field, flow)}
                       onChange={(field, flow, checked) => setFieldValue(`properties.${field}.${flow}Required`, checked)}
        />
    );
}

export default RequiredFieldsSettings;